
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-contact-block--default--default-color:var(--color-neutral-dark);
  --sic-contact-block--default--default-spacing:var(spacing-04);
  --sic-contact-block--default--large-spacing:var(spacing-08);
  --sic-contact-block-link--text-color--hover:var(--color-neutral-white);
  --sic-contact-block-link--bg-color--hover:var(--color-primary-default);
}
`;